import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  getBancos,
} from 'api/configuracion/bancos';

// eslint-disable-next-line react/prop-types
const Bancos = ({ permission }) => (
  <PlainCRUD
    title="Bancos"
    permission={permission}
    readOnly
    get={getBancos}
    fields={[
      defaultFields.nombre,
      {
        name: 'RFC',
        label: 'RFC',
        colWidth: 200,
      },
      {
        name: 'razon_social',
        label: 'Razón social',
        colWidth: 400,
        type: 'textarea',
        autoSize: { minRows: 3, maxRows: 4 },
      },
    ]}
  />
);

export default Bancos;
